const tuple = <T extends [any] | any[]>(args: T): T => args;
export default tuple;
